import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class TrackedByColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.TrackedBy
  declare readonly dataType: typeof MemexColumnDataType.TrackedBy
  declare readonly userDefined: false
}
